import { render } from "./Proposals.vue?vue&type=template&id=17ff6332&bindings={}"
import script from "./Proposals.vue?vue&type=script&lang=ts"
export * from "./Proposals.vue?vue&type=script&lang=ts"
script.render = render

export default script